/*
 * Copyright (c) 2021. Dave van Rijn Development
 */
import './style/asyncSelect.scss';

import React from 'react';
import {PureComponent} from 'react';
import {SelectDefaultProps, SelectProps} from "../selectController";
import {Loader, Select, generateComponentId} from "../../../..";
import classNames from "classnames";

interface Props extends SelectProps {
    onSearch: (value: string, callback: VoidFunction) => void;
    loading: boolean;
}

export default class AsyncSelect extends PureComponent<Props> {
    static defaultProps = SelectDefaultProps;

    private searchValue: string = '';
    private id: string = generateComponentId(this.props.id);

    onChangeSearch = (value: string) => {
        this.searchValue = value;
    };

    onEnter = () => {
        this.props.onSearch(this.searchValue, this.focusInput);
    };

    focusInput = () => {
        const input = document.getElementById(`${this.id}-input`);
        if (input) input.focus();
    };

    render = () => {
        const {loading, fullWidth} = this.props;
        return (
            <div className={classNames('dvr-async-select', fullWidth && 'fw')}>
                <Loader active={loading} containerClass='dvr-async-select-loader' size='2rem' disableBackground/>
                <Select {...this.props} onChangeSearch={this.onChangeSearch} onEnter={this.onEnter} disabled={loading}
                        id={this.id} forceDisplayItems/>
            </div>
        )
    };
}